const vehicleInformationRoutes = <T extends string>(baseRoute: T) => {
  const VEHICLE_INFORMATION = `${baseRoute}/1-fahrzeug`;
  return {
    route: `${VEHICLE_INFORMATION}`,
    INSURANCE_SITUATION: {
      route: `${baseRoute}`,
    },
    VEHICLE_SELECTION_TYPE: {
      route: `${VEHICLE_INFORMATION}/1-2-art`,
    },
    VEHICLE_SELECTION: {
      route: `${VEHICLE_INFORMATION}/1-3-auswahl`,
    },
    CHOSE_YOUR_CAR: {
      route: `${VEHICLE_INFORMATION}/1-4-wahl`,
    },
    KM_PER_YEAR_SELECTION: {
      route: `${VEHICLE_INFORMATION}/1-5-kilometer`,
    },
    OWNER: {
      route: `${VEHICLE_INFORMATION}/1-6-halter`,
    },
    SEASONAL_PLATE: {
      route: `${VEHICLE_INFORMATION}/1-7-kennzeichen`,
    },
    VEHICLE_USAGE: {
      route: `${VEHICLE_INFORMATION}/1-8-nutzung`,
    },
    PARKING_VARIANTS: {
      route: `${VEHICLE_INFORMATION}/1-9-parken`,
    },
    FINANCING: {
      route: `${VEHICLE_INFORMATION}/1-10-finanzierung`,
    },
  } as const;
};

const userRoutes = <T extends string>(baseRoute: T) => {
  const USER = `${baseRoute}/2-nutzer`;
  return {
    route: `${USER}`,
    INSURER_TAKER_SELECTION: {
      route: `${USER}/2-1-versicherungsnehmer`,
    },
    INSURER_TAKER_DATA: {
      route: `${USER}/2-2-vnangaben`,
    },
    DRIVERS_INFORMATION: {
      route: `${USER}/2-3-nutzer`,
    },
    OTHER_VEHICLES: {
      route: `${USER}/2-4-weitere`,
    },
    FLENSBURG_POINTS: {
      route: `${USER}/2-5-punkte`,
    },
    PREVIOUS_INSURANCE: {
      route: `${USER}/2-6-vorversicherung`,
    },
    CLASS_OF_LIABILITY: {
      route: `${USER}/2-7-sfklasse`,
    },
    REPORT_CLAIMS: {
      route: `${USER}/2-8-schaden`,
    },
    PERIOD_PREVIOUS_INSURANCE: {
      route: `${USER}/2-9-vvdauer`,
    },
  } as const;
};

const offerRoutes = <T extends string>(baseRoute: T) => {
  const OFFER = `${baseRoute}/3-angebot`;
  return {
    route: `${OFFER}`,
    PACKAGES: {
      route: `${OFFER}/3-1-angebot`,
    },
    RECOMMENDATIONS: {
      route: `${OFFER}/3-2-optionen`,
    },
  } as const;
};

const contractRoutes = <T extends string>(baseRoute: T) => {
  const CONTRACT = `${baseRoute}/4-antrag`;
  return {
    route: `${CONTRACT}`,
    POLICYHOLDER_DATA: {
      route: `${CONTRACT}/4-1-name`,
    },
    POLICYHOLDER_DETAILS: {
      route: `${CONTRACT}/4-2-adresse-kontakt`,
    },
    FAMILY_DEPENDENTS_DATA: {
      route: `${CONTRACT}/4-3-kinder-partner-sonder`,
    },
    VEHICLE_OWNER_DETAILS: {
      route: `${CONTRACT}/4-4-fhadresse`,
    },
    VEHICLE_SPECIFICATIONS: {
      route: `${CONTRACT}/4-5-km-fahrzeug`,
    },
    INSURANCE_HISTORY: {
      route: `${CONTRACT}/4-6-versicherungsgeschichte`,
    },
    BANK_ACCOUNT_HOLDER_DETAILS: {
      route: `${CONTRACT}/4-7-kontoinhaber`,
    },
    POLICYHOLDER_ADDRESS: {
      route: `${CONTRACT}/4-2-adresse`,
    },
    POLICYHOLDER_CONTACT_DATA: {
      route: `${CONTRACT}/4-3-kontakt`,
    },
    POLICYHOLDER_CHILD_DATA: {
      route: `${CONTRACT}/4-4-kinder`,
    },
    PARTNER_DATA: {
      route: `${CONTRACT}/4-5-partner`,
    },
    OTHER_NCD_DATA: {
      route: `${CONTRACT}/4-6-sondertarif`,
    },
    PREVIOUS_PH: {
      route: `${CONTRACT}/4-7-vorversicherung`,
    },
    VEHICLE_DETAILS: {
      route: `${CONTRACT}/4-8-fahrzeugdaten`,
    },
    VEHICLE_MILAGE: {
      route: `${CONTRACT}/4-9-kilometerstand`,
    },
    VEHICLE_OWNER: {
      route: `${CONTRACT}/4-10-fahrzeughalter`,
    },
    VEHICLE_OWNER_ADDRESS: {
      route: `${CONTRACT}/4-11-fhadresse`,
    },
    IBAN_DATA: {
      route: `${CONTRACT}/4-12-iban`,
    },
    BANK_ACCOUNT_HOLDER: {
      route: `${CONTRACT}/4-13-vnkontoinhaber`,
    },
    BANK_ACCOUNT_HOLDER_INFORMATION: {
      route: `${CONTRACT}/4-14-kontoinhaber`,
    },
    BANK_ACCOUNT_HOLDER_ADDRESS: {
      route: `${CONTRACT}/4-15-koinadresse`,
    },
    SEPA: {
      route: `${CONTRACT}/4-16-sepa`,
    },
  } as const;
};

const summaryRoutes = <T extends string>(baseRoute: T) => {
  const SUMMARY = `${baseRoute}/5-zusammenfassung`;
  return {
    route: `${SUMMARY}`,
  } as const;
};

const confirmationRoutes = <T extends string>(baseRoute: T) => {
  const CONFIRMATION = `${baseRoute}/5-zusammenfassung`;
  return {
    route: `${CONFIRMATION}`,
  } as const;
};

const thankYouRoutes = <T extends string>(baseRoute: T) => {
  const THANK_YOU = `${baseRoute}/6-danke`;
  return {
    route: `${THANK_YOU}`,
  } as const;
};

const errorRoutes = <T extends string>(baseRoute: T) => {
  const ERROR = `${baseRoute}/6-fail`;
  return {
    route: `${ERROR}`,
  } as const;
};

const welcomeRoutes = <T extends string>(baseRoute: T) => {
  const WELCOME = `${baseRoute}/start`;
  return {
    route: `${WELCOME}`,
  } as const;
};

const quickQuoteRoutes = <T extends string>(baseRoute: T) => {
  const QUICK_QUOTE = `${baseRoute}`;
  return {
    WELCOME: {
      route: `${QUICK_QUOTE}/1-start`,
    },
    INSURANCE_HOLDER_DATA: {
      route: `${QUICK_QUOTE}/2-vn`,
    },
    VEHICLE_SELECTION_TYPE: {
      route: `${QUICK_QUOTE}/3-art`,
    },
    VEHICLE_SELECTION: {
      route: `${QUICK_QUOTE}/4-auswahl`,
    },
    CHOOSE_YOUR_CAR: {
      route: `${QUICK_QUOTE}/5-fahrzeug`,
    },
    OFFER: {
      route: `${QUICK_QUOTE}/6-angebot`,
    },
  } as const;
};

export enum Flow {
  NEW_QUOTATION = 'NEW_QUOTATION',
  QUICK_QUOTE = 'QUICK_QUOTE',
}

export enum BasePath {
  NEW_QUOTATION = 'rechner',
  QUICK_QUOTE = 'qq',
}

/**
 * Project routes. Through each router module we control which are the routes available for each flow
 */
const projectRoutes = <T extends string>(baseRoute: T) =>
  ({
    route: baseRoute,
    VEHICLE_INFORMATION: vehicleInformationRoutes(baseRoute),
    USER: userRoutes(baseRoute),
    OFFER: offerRoutes(baseRoute),
    CONTRACT: contractRoutes(baseRoute),
    SUMMARY: summaryRoutes(baseRoute),
    CONFIRMATION: confirmationRoutes(baseRoute),
    THANK_YOU: thankYouRoutes(baseRoute),
    WELCOME: welcomeRoutes(baseRoute),
    QUICK_QUOTE: quickQuoteRoutes(baseRoute),
    ERROR: errorRoutes(baseRoute),
  }) as const;

/**
 * Insert routes in the variable 'route' inside object.
 * Nested routes must be inside the object with the full route
 */
export const RoutePaths = {
  EMPTY: {
    route: '',
  },
  WILDCARD: {
    route: '**',
  },
  COMPONENTS_PREVIEW: {
    route: 'components-preview',
  },
  GENERIC_ERROR: {
    route: 'generischer-fehler',
  },
  MAINTENANCE_PAGE: {
    route: 'wartungsseite',
  },
  [Flow.NEW_QUOTATION]: projectRoutes(BasePath.NEW_QUOTATION),
  [Flow.QUICK_QUOTE]: projectRoutes(BasePath.QUICK_QUOTE),
} as const;
